import React,{useState} from 'react'
import {Link} from 'react-router-dom'
import logo from '../logo.jpg'
import './Styles/navbar.css'
import searchl from '../search-svgrepo-com.svg'
import cart from '../cart.jpg'
import { useSelector,useDispatch } from 'react-redux'
import Cartdialog from './Cartdialog'
import { products } from './Product'
import {logout} from '../app/features/cart'
function Navbar({setcontent}) {
  const dispatch = useDispatch();
  const [open ,setopen] = useState(false);
  const handelclose = ()=>{
    setopen(false);
  }
  const totalamount = useSelector((state)=>state.cart.totalAmount);
  const categories = [
    {id:0,title:"All"},
    {id:1,
    title:"Electronics"},
    {id:2,title:"Fashion & Beauty"} ,
    {id:3,title:"Home Decor"},
    {id:4,title:"Kids Toys"},
    {id:5,title:"Men Fashion"},
    {id:6,title:"Women Fashion"},
    {id:7,title:"Sports Equipment"},
    {id:8,title:"Gardening Tools"},
    {id:9,title:"Pet Foods"},
    {id:10,title:"Cleaning Products"},
  ]
  const [searchr,setsearchr] = useState("");
  const searchresult =(e)=>{
setsearchr(e.target.value);
 setcontent(products.filter((fil)=>fil.title.toLowerCase().includes(searchr.toLowerCase())));
  }
  const refresh =()=>{
    setcontent(products);
    setsearchr("");
  }
  const credential = useSelector((state)=>state.cart.credential)
  return (
    <>
    <nav style={{position:"fixed",top:0,left:0,width:'100%',zIndex:'999'}}>
    <div className="logo">
        <Link to='/'><img src={logo} alt="logo" onClick={refresh}/></Link>
    </div>
    <div className="searchbar">
    <div className="location">
      <p>Hello</p>
      <p className='loci'>select your location</p>
    </div>
    <div className="searchbox">
    <select className='searchselect'> 
     {categories.map((item,index)=>{
      return <option key={index} style={{background:'white'}}>{item.title}</option>
     })}
    </select>
      <input type="search" name="searchbox" id="searchbox" placeholder='Search Amazon' value={searchr}  onChange={searchresult} />
    <i className='searchii'><img src={searchl} alt="search" className='searchi' /></i>
    </div>

    </div>
    <div className="rightcontainer">
      <div className="user">
        { credential === null ? <p><Link to='Login' className='nav-link' style={{textDecorationLine:'none',color:'white'}}>Hello,sign in</Link></p> : <p style={{fontSize:'1.2em',cursor:'pointer'}} onClick={()=>dispatch(logout())}>Logout</p>}
        <p className='userbold'>Account & Lists</p>
      </div>
      <div className="orders">
        <p>orders</p>
        <p className='orderbold'>& Returns</p>
      </div>
      { credential && <div className="cart" onClick={()=>setopen(true)}>
     <span className='cartno'>{totalamount}</span>
        <img src={cart} alt="cart" className='carti' />
      </div>}
    </div>
    <Cartdialog open ={open} onClose={handelclose}/>
    </nav>
    </>
  )
}
export default Navbar
